import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { API_URL } from '../lib/config';
import './AdminPage.css';

function ReportPage() {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('PENDING');
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    useEffect(() => {
        if (!currentUser) return;
        
        const fetchReports = async () => {
            setLoading(true);
            try {
                const idToken = await currentUser.getIdToken();
                const response = await fetch(`${API_URL}/api/admin/reports?status=${activeTab}`,{
                    headers: {
                        'Authorization': `Bearer ${idToken}`
                    }
                });
                const data = await response.json();
                if (response.ok) {
                    setReports(data);
                }
            } catch (error) {
                console.error("신고 목록 로딩 실패:", error);
                setReports([]);
            } finally {
                setLoading(false);
            }
        };
        fetchReports();
    }, [activeTab, currentUser]);

    // [수정] 채팅방 ID를 받아서 올바른 경로로 이동하는 함수
    const handleViewReportDetails = (chatRoomId) => {
        navigate(`/admin/reports/chatroom/${chatRoomId}`);
    };

    if (loading) return <div className="admin-container">신고 목록을 불러오는 중...</div>;

    return (
        <div className="admin-container">
            <h1>신고 관리</h1>
            <div className="admin-tabs">
                <button className={`admin-tab ${activeTab === 'PENDING' ? 'active' : ''}`} onClick={() => setActiveTab('PENDING')}>처리 대기</button>
                <button className={`admin-tab ${activeTab === 'RESOLVED' ? 'active' : ''}`} onClick={() => setActiveTab('RESOLVED')}>처리 완료</button>
            </div>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>신고일</th>
                        <th>신고자</th>
                        <th>피신고자</th>
                        <th>상태 (건수)</th>
                        <th>작업</th>
                    </tr>
                </thead>
                <tbody>
                    {reports.length === 0 ? (
                        <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>해당 상태의 신고 내역이 없습니다.</td></tr>
                    ) : (
                        // [수정] 서버에서 받은 그룹 데이터를 사용
                        reports.map(reportGroup => (
                            <tr key={reportGroup.chatRoomId}>
                                <td>{new Date(reportGroup.createdAt).toLocaleString()}</td>
                                <td>{reportGroup.reportingUsers.map(u => u.userName).join(', ')}</td>
                                <td>{reportGroup.reportedUsers.map(u => u.userName).join(', ')}</td>
                                <td>{reportGroup.status} ({reportGroup.reportIds.length}건)</td>
                                <td>
                                    <button onClick={() => handleViewReportDetails(reportGroup.chatRoomId)}>상세보기</button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default ReportPage;